module.exports = __webpack_public_path__ + "static/media/user_icon.0cd53203.svg";